import React, { useState, useEffect, useContext } from "react"
import styled from "styled-components"
import useSound from "use-sound"
import cubeSFX from "../../../../../lib/audio/cubeBreak.mp3"
import { AppContext } from "../../../../../context/createContext"

export default function Cell({
  type,
  index,
  clickedOn,
  winType,
  isWin,
  handleCollect,
  isClickable,
}: any) {
  const [anim, setanim] = useState(false)
  const [isClicked, setisClicked] = useState(false)
  const {
    audio: { sound, isSoundOff },
  } = useContext(AppContext)

  const [playCubeSFX] = useSound(cubeSFX, {
    volume: parseFloat(sound) / 100,
  })

  const onClick = () => {
    if (type.text === "break cube") {
      setanim(true)
      clickedOn(index)
      !isSoundOff ? setisClicked(true) : setisClicked(false)
    }
    if (isWin) {
      handleCollect(true)
    }
  }

  useEffect(() => {
    setTimeout(() => {
      setanim(false)
    }, 300)
    if (!isSoundOff && isClicked) {
      playCubeSFX()
      setisClicked(false)
    }
  }, [type.text, isSoundOff, isClicked])
  return (
    <CellContainer
      onClick={isClickable ? onClick : () => {}}
      color={type.color}
      background={type.background}
      shadow={type.shadow}
      className={anim ? "transformed" : ""}
      winType={winType !== type.text && isWin}
      win={winType === type.text && isWin}
    >
      <img src={type.svg} />
      {type.text}
    </CellContainer>
  )
}

export const CellContainer = styled.div<{
  color: string
  background: string
  shadow: string
  winType: boolean
  win: boolean
}>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 87.89px;
  height: 75.33px;
  font-weight: 400;
  font-size: 14px;
  line-height: 70%;

  text-transform: uppercase;
  color: ${({ color }) => color};
  box-shadow: ${({ shadow }) => shadow};
  background: ${({ background }) => background};
  border-radius: 8px;
  opacity: ${({ winType }) => (winType ? 0.5 : 1)};
  will-change: transform;
  transform: scale(1);
  transition: opacity 0.3s linear;
  /* opacity: 1; */

  transition: all 100ms linear;
  cursor: pointer;
  user-select: none;
  &.transformed {
    transform: scale(0.8);
    opacity: 0.6;
  }
  img {
    width: 62px;
    /* height: 62px; */
    margin-top: -22px;
    margin-bottom: 10px;
    animation: ${({ win }) => (win ? "heartbeat 1.5s ease-in-out 5 both" : "")};
  }
  @media only screen and (min-width: 768px) {
    width: 150px;
    height: 130px;
    font-size: 24px;
    img {
      width: 93px;
      /* height: 104px; */
      margin-top: -35px;
    }
  }
  @media only screen and (min-width: 1024px) {
    width: 158px;
    height: 135px;
    img {
      width: 97px;
      /* height: 108px; */
      margin-top: -35px;
    }
  }
  @media only screen and (min-width: 1024px) and (max-height: 640px) {
    width: 87.89px;
    height: 75.33px;
    font-size: 14px;
    img {
      width: 62px;
      margin-top: -22px;
      margin-bottom: 10px;
    }
  }
  @keyframes heartbeat {
    from {
      -webkit-transform: scale(1);
      transform: scale(1);
      -webkit-transform-origin: center center;
      transform-origin: center center;
      -webkit-animation-timing-function: ease-out;
      animation-timing-function: ease-out;
    }
    10% {
      -webkit-transform: scale(0.91);
      transform: scale(0.91);
      -webkit-animation-timing-function: ease-in;
      animation-timing-function: ease-in;
    }
    17% {
      -webkit-transform: scale(0.98);
      transform: scale(0.98);
      -webkit-animation-timing-function: ease-out;
      animation-timing-function: ease-out;
    }
    33% {
      -webkit-transform: scale(0.87);
      transform: scale(0.87);
      -webkit-animation-timing-function: ease-in;
      animation-timing-function: ease-in;
    }
    45% {
      transform: scale(1);
      -webkit-animation-timing-function: ease-out;
      animation-timing-function: ease-out;
    }
  }
`
